import { render, staticRenderFns } from "./mallOrderSubmission.vue?vue&type=template&id=7c3c7770&scoped=true"
import script from "./mallOrderSubmission.vue?vue&type=script&lang=js"
export * from "./mallOrderSubmission.vue?vue&type=script&lang=js"
import style0 from "./mallOrderSubmission.vue?vue&type=style&index=0&id=7c3c7770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3c7770",
  null
  
)

export default component.exports